// Values match the API's DeviceSubType enum (see GET /v1/thermostats/latest-readings).
export const ThermostatDeviceSubType = {
  Pelican: 3,
  MilesightLoRa: 15,
} as const;

export type ThermostatDeviceSubTypeId =
  (typeof ThermostatDeviceSubType)[keyof typeof ThermostatDeviceSubType];

// LoRa readings carry no min/max heat/cool settings, so the writable target
// range is assumed fixed for that device type.
export const MILESIGHT_TARGET_RANGE = { min: 50, max: 95 } as const;

// Readings report the keypad as 'On'/'Off' (Pelican) or 'Yes'/'No' (Milesight),
// while Milesight settings are written back as 'Locked'/'Unlocked'.
const unlockedKeypadValues = ['off', 'no', 'unlocked'];

export const isKeypadUnlocked = (value: unknown): boolean =>
  unlockedKeypadValues.includes(String(value).toLowerCase());

export type ThermostatActivity = 'heating' | 'cooling' | 'off' | 'idle';

// "What is this thermostat doing" comes from the device-reported run status
// (e.g. 'HeatStage1', 'CoolStage2', 'Off'), not from UI inference. A system
// turned Off can still report its last stage, so the mode wins there.
export const getThermostatActivity = (
  runStatus: unknown,
  mode: unknown
): ThermostatActivity => {
  if (String(mode).toLowerCase() === 'off') return 'off';
  const status = String(runStatus).toLowerCase();
  if (status.includes('heat')) return 'heating';
  if (status.includes('cool')) return 'cooling';
  return 'idle';
};
